import React, { useRef } from 'react';
import Modal from '../modal/Modal';

const ModalContainer = ({ children, setActive }) => {
  const modal = useRef(null);
  const closeButton = useRef(null);

  const closeModal = () => {
    setActive(null);
  };

  const onKeyDown = (event) => {
    // ESC
    if (event.keyCode === 27) {
      closeModal('esc');
    }
  };

  const onClickOutside = (event) => {
    if (modal && modal.current.contains(event.target)) return;
    closeModal('outside click');
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50">
      <Modal
        modalRef={modal}
        buttonRef={closeButton}
        setActive={setActive}
        closeModal={closeModal}
        onKeyDown={onKeyDown}
        onClickOutside={onClickOutside}
        className="bg-white shadow-lg rounded-lg p-4"
      >
        {React.cloneElement(children, { closeModal })}
      </Modal>
    </div>
  );
};

export default ModalContainer;
